import React from 'react';

function MessagesNoCustomerPageComponent() {
  return <div className="py-20 text-gray-500 font-bold text-xl text-center">Please select customer on the left</div>;
}

export default MessagesNoCustomerPageComponent;
